<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs12>
          <h2 class="headline font-weight-light">
            Extra Charges
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>
      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text" flat>
        <v-layout row>
          <v-flex>
            <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="chargeList"
              label="Select Charge"
              v-model="selectedCharge"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="fromDate"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="fromDate" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            
            <v-flex>
            <v-menu
                :close-on-content-click="false"
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="toDate"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="toDate" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      <!-- End of Firm and Date Filter -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="invoiceHeader"
            :items="getInvoice"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <template>
                <!-- <td>
                  <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
                </td> -->
                <td v-if="!props.item.isTotal" class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                <td v-else>Total</td>
                <!-- <td>
                  <b>{{ props.item['.key']}}</b>
                </td> -->
                <td  v-if="!props.item.isTotal" >
                  <b>{{ props.item['invoiceId']}}</b>
                </td>
                 <td v-else></td>
                <td  v-if="!props.item.isTotal" >
                  <b>{{ getCurrentUserName(props.item.buyerId)}}</b>
                </td>
                <td v-else></td>
                <td  v-if="!props.item.isTotal" >
                  <b class="green--text">{{props.item['ext']['name']}}</b>
                </td>
                <td v-else></td>
                <template v-if="props.item.isTotal">
                  <td>
                    <b class="green--text">{{(props.item.totalCredit).toFixed(2)}}</b>
                  </td>
                  <td>
                    <b class="red--text">{{(props.item.totalDebit).toFixed(2)}}</b>
                  </td>
                </template>
                <template v-else>
                   <template v-if="props.item.isBuyer">
                    <td>
                      <b class="green--text">{{Number.parseFloat(props.item['ext']['amount']).toFixed(2)}}</b>
                    </td>
                    <td>
                      <b class="red--text">0.00</b>
                    </td>
                   </template>
                   <template v-else>
                     <td>
                      <b class="green--text">0.00</b>
                    </td>
                    <td>
                      <b class="red--text">{{Number.parseFloat(props.item['ext']['amount']).toFixed(2)}}</b>
                    </td>
                   </template>
                </template>
                <td v-if="!props.item.isTotal" >
                  <b>{{getFirmName(props.item.firm)}}</b>
                </td>
                <td v-else></td>
                <!-- <td  v-if="!props.item.isTotal" >
                  <b>{{ props.item.paymentType}}</b>
                </td>
                <td v-else></td> -->
              </template>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      invoiceHeader: [
        { text: "Date", value: "date", sortable: true },
        // { text: "Invoice Key", value: "key" },
        { text: "Invoice ID", value: "Block" },
        { text: "Customer Name", value: "Village" },
        { text: "Charges", value: "Block" },
        { text: "Debit", value: "Block" },
        { text: "Credit", value: "Block" },
        { text: "Firm", value: "firm" },
        // { text: "Payment Type", value: "paymentType" }
      ],
      selectedFirm: null,
      fromDate: null,
      toDate: null,
      fromdatepicker: false,
      todatepicker: false,
      chargeList : [],
      selectedCharge : null,
    };
  },
  created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm),
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller)
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    firmsByBrand1() {
      return this.firms
      .filter(item => item["brand"] === this.selectedBrand)  
    },

    // current brands firm list
    firmsByBrand () {
      // return selected brand firms
      let firmsB = this.firms
        .filter((item) => item['brand'] === this.selectedBrand)
        firmsB.map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item;
          }
        })
      return firmsB;
    },
    
    getInvoice() {
      let chargesNames = [];
      let totalDebit= 0
      let totalCredit=0;
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null; 
      let invoices = this.invoices.filter(item => {
        return item["brand"] === this.selectedBrand && (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) && !item["return"] 
        && item['extraCharges'] && item['extraCharges'].length &&
        (this.selectedCharge ? (item['extraCharges'].some((el) => el.name == this.selectedCharge)) : true) &&
        (fromDate ? item.date >= fromDate : true) &&
        (toDate ? item.date <= toDate : true) &&
        (item.deleted != true) &&
        (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
      });
      let invoiceToPass = [];
      invoices.map((invoice, index1) => {
        invoice.extraCharges.map((item,index2) => {
          chargesNames.push(item.name);
          if(!!parseInt(item.amount) && (!this.selectedCharge || this.selectedCharge == item.name)) {
            // totalAmount += Number.parseFloat(item.amount)
            if(invoice.isBuyer) {
              totalCredit += Number.parseFloat(item.amount)
            } else {
              totalDebit += Number.parseFloat(item.amount)
            }
            let inv = JSON.parse(JSON.stringify(invoice))
            inv['ext'] = item;
            invoiceToPass.push(inv);
          }
        })
      });

      invoiceToPass.sort(function(a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      invoiceToPass.push({
        isTotal : true,
        totalDebit : totalDebit,
        totalCredit : totalCredit
      })
      this.chargeList = _.uniq(chargesNames);
      return invoiceToPass;
    },
  },
  methods: {
    getCurrentUserName(buyerId) {
      let buyer = this.buyerById[buyerId];
      let seller = this.sellerById[buyerId];
      let currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },
    // getFirmName(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(item => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  },
  watch: {}
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/ExtraCharges/ExtraChargesInvoices.vue